import { makeStyles } from "@material-ui/core/styles";
import { Button, Typography } from "@material-ui/core";
import { Avatar } from "@material-ui/core";
import { follow } from "../auth/follow";
import { unfollow } from "../auth/unfollow";
import { deleteFollower } from "../auth/deleteFollower";
import { checkFollowBadge } from "../lib/badgeLogic";

const useStyles = makeStyles((theme) => ({
  container: {
    border: `0.5px solid ${theme.palette.text.primary}`,
    padding: theme.spacing(1.7),
    borderRadius: 4,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  subText: {
    fontSize: "14px",
  },
  avatar: {
    width: "30px",
    height: "30px",
  },
  name: {
    display: "flex",
    flex: "1",
    marginLeft: theme.spacing(2),
  },
  requestButtonContainer: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "flex-end",
    gap: theme.spacing(1),
  },
  button: {
    fontSize: "0.7rem",
  },
}));

function UserCard({
  user,
  currentUserId,
  update,
  followingAmount,
  setBadgeContent,
  setFollowerData,
}) {
  const classes = useStyles();

  const { userName, photoUrl, id, buttons } = user;

  const followUser = async () => {
    await follow(id, currentUserId);
  };

  const unfollowUser = async () => {
    await unfollow(id, currentUserId);
  };

  const removeFollower = async () => {
    await deleteFollower(id, currentUserId);
  };

  const handleClick = (buttonType) => {
    if (buttonType === "Folgen") {
      followUser();
      const badgeContent = checkFollowBadge(followingAmount);
      badgeContent && setBadgeContent(badgeContent);
      setFollowerData((prevState) => ({
        ...prevState,
        following: [...prevState.following, user],
      }));
    } else if (buttonType === "Entfolgen") {
      unfollowUser();
      setFollowerData((prevState) => ({
        ...prevState,
        following: [
          ...prevState.following.filter((user) => {
            return user.id !== id;
          }),
        ],
      }));
    } else if (buttonType === "Löschen") {
      removeFollower();
      update();
    } else {
      console.warn("Something went wrong :(");
    }
  };

  const showButton = () => {
    const buttonArr = buttons;

    return buttonArr.map((button, idx) => (
      <Button
        variant="contained"
        color={button === "Folgen" ? "primary" : "default"}
        onClick={() => handleClick(button)}
        className={classes.button}
        size="small"
        key={idx}
      >
        {button}
      </Button>
    ));
  };

  return (
    <>
      <div className={classes.container}>
        <div>
          <Avatar
            className={classes.avatar}
            alt={userName}
            src={photoUrl}
            referrerPolicy="no-referrer"
          />
        </div>
        <div className={classes.name}>
          <Typography variant="subtitle1" className={classes.subText}>
            {userName}
          </Typography>
        </div>
        <div className={classes.requestButtonContainer}>{showButton()}</div>
      </div>
    </>
  );
}

export default UserCard;
